const preventOverflow = (value: string, decimalPlaces: number = 18) => {
    if (!value.includes('.')) return value;

    const parts = value.split('.');
    const fraction = parts[1].slice(0, decimalPlaces);

    return `${parts[0]}.${fraction}`;
};

export default preventOverflow;
